import {apiUserLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";

interface UserPhoneVerifyPayload {
    verification_code: string;
}

export const postUserPhoneVerifyApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postUserPhoneVerify: build.mutation<void, UserPhoneVerifyPayload>({
            query: (request) => {
                const url = apiUserLink.user.verifyPhone;
                return {
                    url,
                    method: "POST",
                    body: request
                };
            },
            transformErrorResponse: (response) => {
                getIgnoredNotifyResponse(response, [400, 409]);

                if (response.status === 400) {
                    return {data: {error: "Kod jest nieprawidłowy, spróbuj ponownie"}, status: 400};
                }
                if (response.status === 409) {
                    return {data: {error: "Numer już zweryfikowany"}, status: 409};
                }
                return response.data;
            },
            invalidatesTags: ["UserProfile"]
        })
    })
});

export const {usePostUserPhoneVerifyMutation} = postUserPhoneVerifyApi;
import {apiUserLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";

interface UserPhoneVerifyPayload {
    verification_code: string;
}

export const postUserPhoneVerifyApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postUserPhoneVerify: build.mutation<void, UserPhoneVerifyPayload>({
            query: (request) => {
                const url = apiUserLink.user.verifyPhone;
                return {
                    url,
                    method: "POST",
                    body: request
                };
            },
            transformErrorResponse: (response) => {
                getIgnoredNotifyResponse(response, [400, 409]);

                if (response.status === 400) {
                    return {data: {error: "Kod jest nieprawidłowy, spróbuj ponownie"}, status: 400};
                }
                if (response.status === 409) {
                    return {data: {error: "Numer już zweryfikowany"}, status: 409};
                }
                return response.data;
            },
            invalidatesTags: ["UserProfile"]
        })
    })
});

export const {usePostUserPhoneVerifyMutation} = postUserPhoneVerifyApi;
